import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import {
  useGetProjectsQuery,
  useGetTeamQuery,
} from "../../features/api/apiSlice";
import {
  useAddTaskMutation,
  useEdiTaskMutation,
} from "../../features/tasks/taskAPI";

function Form({ initialData = {} }) {
  const {
    data: projects,
    isLoading: isProjectsLoading,
    isError: isProjectsError,
  } = useGetProjectsQuery();

  const {
    data: team,
    isLoading: isTeamLoading,
    isError: isTeamError,
  } = useGetTeamQuery();

  let teamOptions = null;
  if (!isTeamLoading && isTeamError) teamOptions = "Something Went Wrong!";
  if (!isTeamLoading && !isTeamError && team?.length === 0)
    teamOptions = "No Team member yet...";
  if (!isTeamLoading && !isTeamError && team?.length > 0)
    teamOptions = team?.map((member) => (
      <option value={member?.id}>{member?.name}</option>
    ));

  let projectOptions = null;
  if (!isProjectsLoading && isProjectsError)
    projectOptions = "Something Went Wrong!";
  if (!isProjectsLoading && !isProjectsError && projects?.length === 0)
    projectOptions = "No Team member yet...";
  if (!isProjectsLoading && !isProjectsError && projects?.length > 0)
    projectOptions = projects?.map((project) => (
      <option value={project?.id}>{project?.projectName}</option>
    ));

  //Form State Management

  const [formState, setFormState] = useState({
    taskName: initialData?.taskName || "",
    teamMember: initialData?.teamMember?.id || "",
    projectName: initialData?.project?.id || "",
    deadline: initialData?.deadline || "",
  });

  function handleFormInput(event) {
    setFormState({ ...formState, [event.target.name]: event.target.value });
  }

  const [addTask, { isSuccess: isAddSuccess }] = useAddTaskMutation();
  const [editTask, { isSuccess: isEditSuccess }] = useEdiTaskMutation();

  function handleSubmit(event) {
    event.preventDefault();

    let payload = { ...formState };
    payload.teamMember = team?.find(
      (member) => member.id === Number(payload.teamMember)
    );
    payload.project = projects?.find(
      (project) => project.id === Number(payload.projectName)
    );
    delete payload.projectName;

    if (initialData?.id) {
      editTask({ data: { ...payload }, id: initialData.id });
    } else {
      addTask(payload);
    }
  }

  const navigate = useNavigate();

  useEffect(() => {
    if (isAddSuccess || isEditSuccess) {
      navigate("/");
    }
  }, [isAddSuccess, isEditSuccess, navigate]);

  return (
    <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
      <form className="space-y-6" onSubmit={handleSubmit}>
        <div className="fieldContainer">
          <label for="lws-taskName">Task Name</label>
          <input
            type="text"
            name="taskName"
            id="lws-taskName"
            required
            placeholder="Implement RTK Query"
            value={formState.taskName}
            onChange={handleFormInput}
          />
        </div>

        <div className="fieldContainer">
          <label>Assign To</label>
          <select
            name="teamMember"
            id="lws-teamMember"
            required
            value={formState.teamMember}
            onChange={handleFormInput}
          >
            <option value="" hidden selected>
              Select Member
            </option>
            {teamOptions}
          </select>
        </div>
        <div className="fieldContainer">
          <label for="lws-projectName">Project Name</label>
          <select
            id="lws-projectName"
            name="projectName"
            value={formState.projectName}
            onChange={handleFormInput}
            required
          >
            <option value="" hidden selected>
              Select Project
            </option>
            {projectOptions}
          </select>
        </div>

        <div className="fieldContainer">
          <label for="lws-deadline">Deadline</label>
          <input
            type="date"
            name="deadline"
            id="lws-deadline"
            value={formState.deadline}
            onChange={handleFormInput}
            required
          />
        </div>

        <div className="text-right">
          <button type="submit" className="lws-submit">
            {initialData?.id ? "Update" : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default Form;
